import { isAddressEqual } from "@opensea/utils"
import { isAddress } from "viem"
import { z } from "zod"
import {
  ADDRESS_VALIDATION_MESSAGES,
  addressSchema,
} from "../../../lib/zod/address"

const itemSchema = z
  .object({
    ownedQuantity: z.int(),
    quantity: z.int().min(1, "Please enter a valid quantity."),
    id: z.string(),
  })
  .refine(data => data.quantity <= data.ownedQuantity, {
    message: "You don't have enough of this item.",
    path: ["quantity"],
  })

export const transferFlowFormSchema = z.object({
  recipient: addressSchema
    .refine(
      ({ resolvedAddress, identifier, currentAddress }) => {
        const address = resolvedAddress ?? identifier

        if (!(address && isAddress(address))) {
          return true
        }

        return !isAddressEqual(address, currentAddress)
      },
      {
        message: ADDRESS_VALIDATION_MESSAGES.cannotTransferToSelf,
        path: ["identifier"],
      },
    )
    .refine(({ identifier }) => Boolean(identifier), {
      message: "Please enter a valid address or ENS name.",
      path: ["identifier"],
    }),
  items: z.array(itemSchema).min(1, "At least one item must be transferred."),
})
